<template>
  <div class="system-page" id="app" style="overflow-y: scroll;">
    <mt-header :title="'物品领用审批'">
      <mt-button icon="back" slot="left" @click.native="goBack">返回</mt-button>
    </mt-header>
    <div v-if="isLoading" class="back-loading">数据加载中...</div>
    <div class="header" style="display: flex; align-items: center; padding: 0 0; background-color: #f5f5f5;position: sticky; top: 0">
      <div class="scrollable-content" id="scrollableContent" style="height: auto;">
        <div style="width: 24rem;">
          <table class="bo table ">
            <tr >
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">提单人员</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 20px;margin-left: -320px">{{item.userName}}</div></td>
            </tr>
            <tr >
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">提单日期</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 20px;margin-left: -320px">{{item.applyTime}}</div></td>
            </tr>
            <tr >
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">流程状态</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 20px;margin-left: -320px">{{item.statusName}}</div></td>
            </tr>
            <tr class="top ss">
              <td colspan="14" class="wi "><div class="bottom" ><label style="margin-top: 10px;font-size:30px;height: 20px;color: #6d9eeb">申请明细</label></div></td>
            </tr>
            <tr class="rile">
              <td class="wi"><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">附件</label></td>
              <td colspan="7" style="width:160px;">
                <div v-if="attachments.length!=0"style="width:260px;margin-left: -262px;margin-top: 10px;font-size:20px;overflow-wrap: break-word; white-space: normal;line-height: 20px">
                  <div
                      v-for="(item, idx) in attachments"
                      :key="idx"
                      style="display: flex; align-items: center; margin-bottom: 5px;margin-left: -40px">
                    <span>{{ item.attachmentName }} <div class="nameusersub" @click.prevent="previewFile(item)">预览</div></span>
                  </div>

                </div>
                <div v-else  style="width:260px;margin-left: -262px;margin-top: 10px;font-size:20px;overflow-wrap: break-word; white-space: normal;line-height: 20px">
                  <div   style="display: flex; align-items: center; margin-bottom: 5px;margin-left: -40px">
                    <span>无文件</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr class="rile" >
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">备注</label></td>
              <td colspan="7" style="width:160px;">
                <div style="width:260px;margin-top: 10px;font-size:20px;overflow-wrap: break-word; white-space: normal;line-height: 20px;margin-left: -320px">
                  {{item.processDescribe}}
                </div></td>
            </tr>
            <div>
              <tr >
                <td class="wi" style="width: 50px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;width: 160px;color: #6d9eeb">物品名称</label></td>
                <td class="wi" style="width: 50px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;width: 160px;color: #6d9eeb;">规格型号</label></td>
                <td class="wi" style="width: 50px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;width: 160px;color: #6d9eeb;">数量</label></td>
              </tr>
            </div>
            <div
                v-for="(item, idx) in items"
            >
              <tr >
                <td class="wi" style="width: 50px;" ><label style="margin-top: 10px;font-size:20px;line-height: 20px;height: 20px;width: 160px;">{{item.itemName}}</label></td>
                <td class="wi" style="width: 50px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;width: 160px;">{{item.itemModel}}</label></td>
                <td class="wi" style="width: 50px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;width: 160px;">{{item.number}}</label></td>
              </tr>
            </div>
            <tr >
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb">审核状态</label></td>
              <td colspan="7" style="width:160px;"><div style="margin-top: 10px;font-size:20px;height: 20px">
                <input style="width: 250px;height: 28px;font-size: 20px;margin-left: -320px" v-model="item.restatusName" readonly label="审核状态" @click.prevent="statusVisible = true"/>
                <i class="mintui mintui-field-error" style="margin-left: -188px;" @click.prevent="statusVisible = true"></i>
              </div>
              </td>
            </tr>
<!--            <tr>-->
<!--              <td class="wi" style="width: 100px !important; vertical-align: top;">-->
<!--                <label style="margin-top: 10px; font-size: 20px; height: 20px; color: #6d9eeb">签字</label>-->
<!--              </td>-->
<!--              <td colspan="7" style="width:160px;">-->
<!--                <div style="display: flex; align-items: center; gap: 10px;margin-left: -320px">-->
<!--                  <input type="file" id="signUpload" accept="image/*" style="display: none;"-->
<!--                         @change="handleSignatureUpload">-->
<!--                  <button v-if="!signatureImage" type="button"-->
<!--                          class="signPicture"-->
<!--                          @click="triggerFileUpload">-->
<!--                    上传签字-->
<!--                  </button>-->
<!--                  <div v-if="signatureImage" style="position: relative;">-->
<!--                    <img :src="signatureImage" style="max-height: 50px; border: 1px solid #ddd;">-->
<!--                    <button type="button" style="position: absolute; top: -10px; right: -10px; background: red; color: white; border-radius: 50%; width: 20px; height: 20px; border: none;"-->
<!--                            @click="removeSignature">-->
<!--                      ×-->
<!--                    </button>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </td>-->
<!--            </tr>-->
            <tr>
              <td class="wi" style="width: 100px;" ><label style="margin-top: 10px;font-size:20px;height: 20px;color: #6d9eeb;">审核意见</label></td>
              <td colspan="7" style="width:160px;">
                <div>
                  <input style="width: 250px;height: 28px;font-size: 20px;margin-left: -320px" v-model="item.advice" label="审核意见" />
                </div>
              </td>
            </tr>
          </table>
            <div class="sub" @click.prevent="jieanSubmit":disabled="isSubmitting"> {{ isSubmitting ? '提交中...' : '审核并结案' }}</div>
        </div>
      </div>
    </div>
    <!-- 状态选择 -->
    <mt-popup
        style="width: 100%"
        v-model="statusVisible"
        position="bottom"
        popup-transition="popup-fade"
    >
      <mt-header>
        <mt-button @click.native="statusVisible = false" slot="left"
        >关闭</mt-button
        >
        <mt-button @click.native="selectStatusPicker" slot="right"
        >确认</mt-button
        >
      </mt-header>
      <mt-picker
          :slots="statusList"
          ref="statusList"
          valueKey="name"
      ></mt-picker>
    </mt-popup>
  </div>
</template>

<script>
import tabModule from "@/components/footerBar/index.vue";
import { getLocalData } from "@/utils/sessionData.js";
import request from "@/utils/keyCloakRequest";
import axios from "axios";
import {Indicator, Toast} from "mint-ui";
export default {
  components: {
    "v-tab-module": tabModule,
  },
  beforeMount() {},
  data() {
    return {
      isSubmitting: false,
      filePath:'',
      signatureImage: null,
      statusList:[
        {
          values: [
            {
              code: "25",
              name: "已批准"
            },
            {
              code: "26",
              name: "未通过"
            }
          ],
          className: "slot1"
        }
      ],
      statusVisible: false,
      reviewedId:'',
      item:{},
      route:'',
      userInfo: {},
      isLoading: false,
      attachments:[],
      items:[],
    };
  },
  async created() {
    this.userInfo = JSON.parse(getLocalData("userInfo"))
    this.reviewedId = this.$route.query.item.reviewedId;
    axios({
      url: process.env.VUE_APP_SSO_URL+"appReceivedShenDetail?reviewedId="+this.reviewedId,
      method: "get",
    }).then(response => {
      this.item = response.data
      this.item.reviewedId = this.reviewedId
      this.items = response.data.pitems
      this.item.statusId = 25
      this.item.restatusName='已批准'
      if(this.item.proFileid!="") {
        request({
          url: "appDocumentFile?fileIds=" + this.item.proFileid,
          method: "get"
        }).then(response => {
          this.attachments = response
        })
      }
      this.allLoaded = true;
      Indicator.close();
    })
    this.route =  this.$route.query.route
  },
  mounted() {
  },

  methods: {
    async handleSignatureUpload(e) {
      const file = e.target.files;
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (event) => {
        this.signatureImage = event.target.result;
      };
      reader.readAsDataURL(file[0]);
      this.filePath = file[0]
      await axios({
        url: process.env.VUE_APP_SSO_URL+"appUploadSignPicture",
        method: "POST",
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: {filePath:this.filePath}
      }).then(res => {
        this.item.signPicture = res.data
      })
    },
    triggerFileUpload() {
      document.getElementById('signUpload').click();
    },
    removeSignature() {
      this.signatureImage = null;
      document.getElementById('signUpload').value = '';
    },
    previewFile(attachment){
      this.$router.push({
        name: 'filePreview',
        query: {
          attachment: attachment,
          item: this.item,
          route:this.route,
          name:'shenReceivedDetail'
        },
      });
    },
    jieanSubmit(){
      if (!this.item.advice) {
        Toast({
          message: "请填写审核意见"
        });
        return;
      }
      this.isSubmitting = true;
      axios({
        url: process.env.VUE_APP_SSO_URL+"appReceivedjiean",
        method: "POST",
        data:this.item
      }).then(res => {
        console.log(res)
        if(res.data=='sucess'){
          Toast({
            message: "审批成功",
            position: 'middle',
            iconClass: "icon icon-success"
          });
          this.goBack();
        }
        else {
          Toast({
            message: res.data,
            position: 'middle',
            iconClass: "icon icon-success"
          });
        }
      })
    },
    selectStatusPicker() {
      this.item.statusId = this.$refs.statusList.getValues()[0].code;
      this.item.restatusName =  this.$refs.statusList.getValues()[0].name;
      this.statusVisible = false;
    },
    goBack() {
      this.$router.push(this.route);
    },
  },
};
</script>

<style lang="less">
@color: #ffffff;
@border-rd: 0.6rem;

html {
  overflow: hidden;
  height: 100%;
  background: #f5f5f5;
}

body {
  display: block;
  margin: 0rem !important;
}
.app {
  /* padding: 0.5rem; */
  background-color: rgb(240, 240, 240, 0.75);
}
.signPicture{
  width: 35%;
  height: 120px;
  line-height: 100px;
  font-size: 75px;
  background: green;
  border-radius: 50px 50px 50px 50px;
  text-align: center;
  cursor: pointer;
  color: #e5f4f9;
  //margin-left: -1050px;
}
.sub {
  width: 80%;
  height: 200px;
  line-height: 200px;
  font-size: 75px;
  background: #5f9cf5;
  border-radius: 50px 50px 50px 50px;
  text-align: center;
  cursor: pointer;
  color: #e5f4f9;
  margin-top: -50px;
  margin-left: 50px;
}
.menuTitle {
  font-size: 1rem;
}
.sub[disabled] {
  opacity: 0.6;
  width: 80%;
  height: 200px;
  line-height: 200px;
  font-size: 75px;
  background: #5f9cf5;
  border-radius: 50px 50px 50px 50px;
  text-align: center;
  color: #e5f4f9;
  margin-top: 100px;
  margin-left: 50px;
  cursor: not-allowed;
}
.nameusersub{
  width: 40%;
  height: 100px;
  line-height: 100px;
  background: #5cb85c;
  border-radius: 50px 50px 50px 50px;
  text-align: center;
  cursor: pointer;
  color: #e5f4f9;
}
.system-page {
  width: 100%;
  height: 100vh;
  background-color: #f1f5f8;
  font-family: "PingFangSC-Regular";
}
/** 加载中 */
.back-loading {
  width: 100%;
  height: 100%;
  background-color: white;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  text-align: center;
  line-height: 25rem;
  font-size: 1rem;
  color: grey;
}
</style>
